import React, { useEffect } from "react";
import { connectHits } from "react-instantsearch-dom";
import { compose } from "@wordpress/compose";
import { withSelect, withDispatch } from "@wordpress/data";
import Track from "./Track";

const hits = ({
  hits,
  playingTrack,
  addingTrack,
  energyDisplayColumn,
  shapeDisplayColumn,
  tracks,
  selectedTracks,
  setTracks,
}) => {
  useEffect(() => {
    setTracks(hits);
  }, [hits]);

  return (
    <div className="ais-Hits">
      <ul className="ais-Hits-list">
        {tracks.map((hit) => (
          <li key={hit.objectID} className="ais-Hits-item">
            <Track
              track={hit}
              playingTrack={playingTrack}
              addingTrack={addingTrack}
              energyDisplayColumn={energyDisplayColumn}
              selectedTracks={selectedTracks}
              shapeDisplayColumn={shapeDisplayColumn}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

const Hits = compose(
  withSelect((select, ownProps) => {
    const {
      getPlayingTrack,
      getAddingTrack,
      getEnergyDisplayColumn,
      getShapeDisplayColumn,
      getTracks,
      getSelectedTracks,
    } = select("hifi");

    return {
      ...ownProps,
      tracks: getTracks(),
      selectedTracks: getSelectedTracks(),
      playingTrack: getPlayingTrack(),
      addingTrack: getAddingTrack(),
      energyDisplayColumn: getEnergyDisplayColumn(),
      shapeDisplayColumn: getShapeDisplayColumn(),
    };
  }),
  withDispatch((dispatch) => {
    const { setTracks } = dispatch("hifi");

    return {
      setTracks,
    };
  })
)(hits);

// todo wrap below around withSelect
export default connectHits(Hits);
